var axios = require('axios');

module.exports = axios.create({
  baseURL: 'https://printerconnect.com.br/api/index.php/',
  timeout: 25000, 
});


